export default __webpack_public_path__ + "static/media/ic_user.03fe764d.svg";